module.exports = __webpack_public_path__ + "static/img/loginlogo.fb31b8a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/login/loginlogo.png
// module id = xdSd
// module chunks = 0